import { TrendDataPointMock } from './chart-types';

/**
 * A trend point's automated and manual volume.
 *
 * Live analytics responses carry only the two-way `total_automated` / `total_manual`; the four-way
 * high-confidence / rule / low-confidence / rule split exists only in the POC's mock payloads. Use
 * the four-way fields when a point has any of them, and the two-way totals otherwise. Summing four
 * absent fields gives zero, which silently empties every view derived from the point.
 */
export const hasFourWaySplit = (d: TrendDataPointMock): boolean =>
  d.automated_high_confidence !== undefined ||
  d.automated_rule !== undefined ||
  d.manual_low_confidence !== undefined ||
  d.manual_rule !== undefined;

export const automatedManualOf = (
  d: TrendDataPointMock
): { automated: number; manual: number } =>
  hasFourWaySplit(d)
    ? {
        automated: (d.automated_high_confidence ?? 0) + (d.automated_rule ?? 0),
        manual: (d.manual_low_confidence ?? 0) + (d.manual_rule ?? 0)
      }
    : {
        automated: d.total_automated ?? 0,
        manual: d.total_manual ?? 0
      };
